import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export function Home() {
  const { loading, loggedIn, user, logout } = useAuth();
  return (
    <div className="space-y-20">

      {/* HERO SECTION */}
      <section className="text-center mt-10">
        <h1 className="text-4xl font-bold mb-4">
          Prepare Smarter. <span className="text-[#4FC3F7]">Win More.</span>
        </h1>

        <p className="text-lg text-muted max-w-2xl mx-auto">
          Opponent scouting and league intelligence for FACEIT & ESEA teams.
          Analyze rosters, player roles, ELO, availability, and season
          performance — all in one place.
        </p>

        {/* LOGIN CTA */}
        <div className="mt-10 flex flex-col items-center gap-4">
          {loading ? (
            <div className="text-sm text-muted">Checking your session...</div>
          ) : loggedIn ? (
            <>
              <div className="text-sm text-muted">
                Welcome back{user?.nickname ? `, ${user.nickname}` : ""}.
              </div>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <NavLink
                  to="/dashboard"
                  className="
                    px-6 py-3 rounded-md font-semibold
                    bg-[#4FC3F7] text-[#0C0F14]
                    hover:bg-[#81D4FA]
                    transition
                  "
                >
                  Go to Dashboard
                </NavLink>
                <button
                  type="button"
                  onClick={() => void logout()}
                  className="
                    px-6 py-3 rounded-md font-semibold border border-border
                    hover:border-[#4FC3F7] hover:text-[#4FC3F7]
                    transition
                  "
                >
                  Log out of Steam
                </button>
              </div>
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={() => {
                  window.location.href = "/auth/steam";
                }}
                className="
                  px-6 py-3 rounded-md font-semibold
                  bg-[#4FC3F7] text-[#0C0F14]
                  hover:bg-[#81D4FA]
                  transition
                "
              >
                Login with Steam
              </button>

              <p className="text-sm text-muted max-w-md">
                Log in with your Steam account to access opponent profiles,
                player stats, match preparation tools, and season insights.
              </p>
            </>
          )}
        </div>
      </section>

      {/* FEATURE GRID */}
      <section className="grid md:grid-cols-3 gap-8">
        
        <div className="p-6 rounded-lg bg-surface border border-border hover:border-[#4FC3F7] transition">
          <h3 className="text-xl font-semibold mb-2">Opponent Profiles</h3>
          <p className="text-muted text-sm">
            Full roster breakdowns, player roles, ELO, and recent performance
            trends for every team you face this season.
          </p>
        </div>

        <div className="p-6 rounded-lg bg-surface border border-border hover:border-[#4FC3F7] transition">
          <h3 className="text-xl font-semibold mb-2">Match Preparation</h3>
          <p className="text-muted text-sm">
            Track upcoming matches, analyze opponent tendencies, and prepare
            smarter with consolidated league insights.
          </p>
        </div>

        <div className="p-6 rounded-lg bg-surface border border-border hover:border-[#4FC3F7] transition">
          <h3 className="text-xl font-semibold mb-2">Player Intelligence</h3>
          <p className="text-muted text-sm">
            Deep player stats including ELO, map pool, performance history, and
            availability indicators.
          </p>
        </div>

      </section>

      {/* SECOND ROW OF FEATURES */}
      <section className="grid md:grid-cols-3 gap-8">

        <div className="p-6 rounded-lg bg-surface border border-border hover:border-[#4FC3F7] transition">
          <h3 className="text-xl font-semibold mb-2">Season Tracking</h3>
          <p className="text-muted text-sm">
            Monitor standings, match results, and team form throughout the
            season to stay ahead of the competition.
          </p>
        </div>

        <div className="p-6 rounded-lg bg-surface border border-border hover:border-[#4FC3F7] transition">
          <h3 className="text-xl font-semibold mb-2">Demo Insights</h3>
          <p className="text-muted text-sm">
            Quickly access match demos and identify patterns, weaknesses, and
            strategic tendencies.
          </p>
        </div>

        <div className="p-6 rounded-lg bg-surface border border-border hover:border-[#4FC3F7] transition">
          <h3 className="text-xl font-semibold mb-2">Team Coordination</h3>
          <p className="text-muted text-sm">
            Availability tracking and lineup stability indicators help you plan
            for every match with confidence.
          </p>
        </div>

      </section>

    </div>
  );
}
